import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useAddOfficeDivision from "./hooks/useAddOfficeDivision";
import useOfficeDivision from "./hooks/useOfficeDivision";
import { useRecoilState } from "recoil";
import MaterialExTable from "../../../../components/tables/MaterialExTable";
import {
  addStateOfficeDivision,
  setFilterTextOfficeDivision,
} from "./atoms/atoms";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import { useQueryClient } from "react-query";

const OfficeDivisionForm = () => {
  const { mutateAsync: AddOfficeDivision } = useAddOfficeDivision();
  const { data, isFetching } = useOfficeDivision();
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateOfficeDivision
  );

  const [filterText, setFilterText] = useRecoilState(
    setFilterTextOfficeDivision
  );
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasOfficeDivision, setHasOfficeDivision] = useState(false);
  const userAccount = useRecoilState(accountAtom);
  const queryClient = useQueryClient();

  const defaulValues = {
    divisionId: 0,
    divisionName: "",
    divisionCode: "",
    createdBy: "",
    createdOn: null,
    isActive: 0,
  };
  const [officedivisionNewData, setOfficeDivisionNewData] = useState([
    defaulValues,
  ]);
  const [OfficeDivisionExist, setOfficeDivision] = useState(false);

  const handleAddOfficeDivision = (SourceType, fieldName, e) => {
    e = e.trim();
    if (SourceType?.toLowerCase() === "addofficedivisionname") {
      officedivisionNewData.map((x) => (x[fieldName] = e));
      officedivisionNewData.map((x) => (x.isActive = true));

      const result = data.filter(
        (item) =>
          item.divisionName?.toUpperCase() ===
          officedivisionNewData[0].divisionName?.toUpperCase()
      );

      if (result.length > 0 && result !== undefined) {
        setHasOfficeDivision(false);
        setChanged(false);
      } else {
        setHasOfficeDivision(true);

        let reqFields = ["divisionName", "divisionCode"];
        if (
          reqFields.includes(fieldName) &&
          officedivisionNewData[0].divisionName &&
          officedivisionNewData[0].divisionCode &&
          e !== ""
        ) {
          setChanged(true);
        } else if (
          fieldName === "divisionCode" &&
          officedivisionNewData[0].divisionCode
        ) {
          setChanged(true);
        } else {
          setChanged(false);
        }
      }
    }

    if (SourceType?.toLowerCase() === "addofficedivisioncode") {
      officedivisionNewData.map((x) => (x[fieldName] = e));
      officedivisionNewData.map((x) => (x.isActive = true));

      const result = data.filter(
        (item) =>
          item.divisionCode?.toUpperCase() ===
          officedivisionNewData[0].divisionCode?.toUpperCase()
      );

      if (result.length > 0 && result !== undefined) {
        setHasOfficeDivision(false);
        setChanged(true);
      } else {
        setHasOfficeDivision(true);

        let reqFields = ["divisionName", "divisionCode"];
        if (
          reqFields.includes(fieldName) &&
          officedivisionNewData[0].divisionName &&
          officedivisionNewData[0].divisionCode &&
          e !== ""
        ) {
          setChanged(true);
        } else if (
          fieldName === "divisionName" &&
          officedivisionNewData[0].divisionName
        ) {
          setChanged(true);
        } else {
          setChanged(false);
        }
      }
    }
  };

  const handleSave = (officedivisionNewData) => {
    setOpenModal(false);
    if (actionAddState) {
      AddOfficeDivision(officedivisionNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModal(false);
          } else {
            setActionAddState(false);
            setOfficeDivisionNewData([defaulValues]);
            queryClient.invalidateQueries(["GetOfficeDivision"]);
            toast.fire(
              "Success",
              "Office Division Added Successfully",
              "success"
            );
            setOpenModal(false);
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Add OfficeDivision", "error");
          queryClient.invalidateQueries(["GetOfficeDivision"]);
        },
      });
    }
  };

  const matcolumns = [
    {
      title: "Division Code",
      field: "divisionCode",
      render: (rowData) => {
        return (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              defaultValue={rowData.divisionCode}
              onChange={(e) => {
                handleAddOfficeDivision(
                  "addofficedivisioncode",
                  "divisionCode",
                  e.target.value
                );
              }}
            />
          </div>
        );
      },
    },
    {
      title: "Division Name",
      field: "divisionName",
      render: (rowData) => {
        return (
          <div className="w-full ">
            <TextInput
              defaultValue={rowData.divisionName}
              onChange={(e) =>
                handleAddOfficeDivision(
                  "addofficedivisionname",
                  "divisionName",
                  e.target.value
                )
              }
            />
          </div>
        );
      },
    },
  ];
  return (
    <div className="animate-fade-in-down">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add OfficeDivision"
          qConfirmation="Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(officedivisionNewData);
          }}
        />
        <div className="p-3  space-y-1 border-l-2  border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold ">
              Add New Office Division
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <SaveButton
                className={`flex items-left shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasOfficeDivision || !changed ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasOfficeDivision || !changed}
                onClick={() => setOpenModal(true)}
              />
              <CancelButton
                className="flex items-left text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary  hover:bg-octonary px-2 py-1 "
                onClick={() => {
                  setActionAddState(!actionAddState);
                  setFilterText("");
                }}
              />
            </div>
          </div>

          <div className="mt-2 h-0.5 w-full border-b-2 border-secondary mb-5"></div>

          <div className="py-1"></div>

          <div className="space-y-5 space-x-2 space-y-20 w-full  ">
            <MaterialExTable
              columns={matcolumns}
              data={officedivisionNewData}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="pb-1.5"></div>
        </div>
      </div>
    </div>
  );
};

export default OfficeDivisionForm;
